import React from 'react';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
  useSortable
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Reorder } from '@mui/icons-material';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';

const SortableItem = ({ item, itemIndex, highlightIndex }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    backgroundColor: highlightIndex === itemIndex ? '#f0f0f0' : 'white',
  };

  return (
    <TableRow
      ref={setNodeRef}
      {...attributes}
      sx={{ ...style }}
    >
      <TableCell {...listeners} sx={{ width: '50px', px: 1, cursor: 'grab' }}>
        <Reorder />
      </TableCell>
      <TableCell>
        <Typography variant="body1">
          {item.title}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

const QuickTapsFeaturedList = ({ items, onSortEnd, highlightIndex }) => {
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
      const oldIndex = items.findIndex((item) => item.id === active.id);
      const newIndex = items.findIndex((item) => item.id === over.id);
      onSortEnd({ oldIndex, newIndex });
    }
  };

  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragEnd={handleDragEnd}
    >
      <TableContainer>
        <Table>
          <TableBody>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell sx={{ width: '50px', px: 1, whiteSpace: 'nowrap' }}><strong>Sort</strong></TableCell>
              <TableCell><strong>Title</strong></TableCell>
            </TableRow>
            <SortableContext
              items={items.map((item) => item.id)}
              strategy={verticalListSortingStrategy}
            >
              {items.map((value, index) => (
                <SortableItem
                  key={`item-${index}`}
                  highlightIndex={highlightIndex}
                  itemIndex={index}
                  item={value}
                />
              ))}
            </SortableContext>
          </TableBody>
        </Table>
      </TableContainer>
    </DndContext>
  );
};

export default QuickTapsFeaturedList;